// frontend/src/pages/LoginPage.js

import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, TextField, Typography, Paper, Alert, Link, CircularProgress } from '@mui/material';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await login(email, password); 
      window.location.href = '/'; 
    } catch (err) {
      const msg = err.response?.data?.detail || 'Falha no login. Verifique seu email e senha.';
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      backgroundColor: 'rgba(255, 255, 255, 0.06)',
      color: '#FFFFFF',
      '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.20)' },
      '&:hover fieldset': { borderColor: 'rgba(255, 255, 255, 0.40)' },
      '&.Mui-focused fieldset': { borderColor: '#3897F0' },
    },
    '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.65)' },
    '& .MuiInputLabel-root.Mui-focused': { color: '#3897F0' },
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #030D1B 0%, #071933 50%, #020914 100%)',
        p: 2,
      }}
    >
      <Paper 
        component="form" 
        onSubmit={handleLogin} 
        elevation={12} 
        sx={{ 
          padding: { xs: 3, sm: 4.5 }, 
          width: '100%',
          maxWidth: 420, 
          textAlign: 'center',
          borderRadius: 4,
          backgroundColor: 'rgba(7, 25, 51, 0.88)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(255, 255, 255, 0.12)',
          boxShadow: '0 20px 50px rgba(0, 0, 0, 0.6)',
          color: '#FFFFFF',
        }}
      >
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <img 
            src="/logo-completa.png" 
            alt="ITAPOÁ SIGN" 
            style={{ 
              maxHeight: 125, 
              maxWidth: '100%', 
              objectFit: 'contain',
              borderRadius: 8,
            }} 
          />
        </Box>
        
        <Typography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 700, letterSpacing: '0.8px' }}>
          ITAPOÁ SIGN
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'rgba(255, 255, 255, 0.65)', fontWeight: 400 }}>
          Assinatura Digital - Câmara Municipal de Itapoá
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2, textAlign: 'left' }}>{error}</Alert>}

        <TextField 
          fullWidth 
          label="Email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          margin="normal" 
          required 
          variant="outlined"
          sx={inputStyle}
        />
        
        <TextField 
          fullWidth 
          label="Senha" 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          margin="normal" 
          required 
          variant="outlined"
          sx={inputStyle}
        />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1.5, mb: 1.5 }}>
          <Link component={RouterLink} to="/esqueci-senha" variant="body2" sx={{ color: '#3897F0', fontWeight: 500, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
            Esqueci a senha?
          </Link>
          <Link component={RouterLink} to="/register" variant="body2" sx={{ color: '#3897F0', fontWeight: 500, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
            Cadastre-se
          </Link>
        </Box>

        <Button 
          type="submit" 
          fullWidth 
          variant="contained" 
          disabled={isLoading}
          sx={{ 
            mt: 2, 
            py: 1.4,
            borderRadius: 2.5,
            fontSize: '1rem',
            fontWeight: 600,
            textTransform: 'none',
            background: 'linear-gradient(to right, #0D6EFD, #0052CC)',
            boxShadow: '0 4px 16px rgba(13, 110, 253, 0.45)',
            '&:hover': {
              background: 'linear-gradient(to right, #0b5ed7, #0040a8)',
            }
          }}
        >
          {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
        </Button>
      </Paper>

      <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <Link 
          component={RouterLink} 
          to="/politica-de-privacidade" 
          variant="caption" 
          sx={{ color: '#3897F0', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
        >
          Política de Privacidade e Proteção de Dados
        </Link>
        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.45)', textAlign: 'center', letterSpacing: '0.3px' }}>
          Powered by Câmara Municipal de Itapoá-SC
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginPage;